import axios from 'axios'

export const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  // baseURL: 'https://api.ronad.ir/v1',
  headers: {
    'Content-Type': 'application/json'
  }
})

api.interceptors.request.use(
  function (config) {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  function (error) {
    return Promise.reject(error)
  }
)

// api.interceptors.response.use(
//   function (response) {
//     return response.data.data ?? response.data
//   },
//   function (error) {
//     return error.response.status === 401
//       ? refreshToken().then(() => api.request(error.config))
//       : Promise.reject(error.response)
//   }
// )
